// Pages that use the feed pack also use stuff like MentionableComments
// So, we will import the main 'strava_with_framework' that imports
// and registers that component.
import './strava_with_framework';

import ReactComponentMounter from '../utils/react-component-mounter';

// Feed specific components:
import Feed from '../components/Feed';
// 4/21/21 - MaharajAchievementCelebration is being used app/views/feed3p0/achievement_celebration/_base.haml
import MaharajAchievementCelebration from '../components/Feed/components/shared/MaharajAchievementCelebration';
import Activity from '../components/Feed/components/Activity';
import Post from '../components/Feed/components/Post';
import ChallengeJoin from '../components/Feed/components/ChallengeJoin';
import ClubJoin from '../components/Feed/components/ClubJoin';
import FancyPromo from '../components/Feed/components/FancyPromo';
import SimplePromo from '../components/Feed/components/SimplePromo';
import GroupActivity from '../components/Feed/components/GroupActivity';
import PerformanceGoalCreated from '../components/Feed/components/PerformanceGoalCreated';

// Modules from <packs />
import EmailVerificationCTA from '../components/EmailVerificationCTA';
import NotificationEmailVerificationCTA from '../components/EmailVerificationCTA/placements/NotificationEmailVerificationCTA';

ReactComponentMounter.register({
  Feed,
  MaharajAchievementCelebration,
  Activity,
  Post,
  ChallengeJoin,
  ClubJoin,
  FancyPromo,
  SimplePromo,
  GroupActivity,
  PerformanceGoalCreated,
  EmailVerificationCTA,
  NotificationEmailVerificationCTA
});
